let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4RTC0")).then(() => parcelRequire('9XKDI'));